import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { GroupListService } from '../services/group-list.service';
import { GroupDetailService } from '../services/group-detail.service';

export const groupListResolver: ResolveFn<void> = (
    route: ActivatedRouteSnapshot,
) => {
    const groupListService = inject(GroupListService);
    const groupType = route.paramMap.get('groupType');

    if (groupType) {
        try {
            groupListService.loadGroupListAttributes(groupType);
        } catch (error) {
            console.error('Error setting current group type:', error);
            throw error;
        }
    } else {
        throw new Error('groupType parameter is missing in the route');
    }
};

export const groupDetailResolver: ResolveFn<void> = (
    route: ActivatedRouteSnapshot,
) => {
    const groupDetailService = inject(GroupDetailService);
    const groupType = route.paramMap.get('groupType');
    const id = route.paramMap.get('id');

    if (groupType) {
        try {
            groupDetailService.loadGroupDetailAttributes(groupType);
            if (id) groupDetailService.loadDetailData(Number(id));
        } catch (error) {
            console.error('Error setting current group type:', error);
            throw error;
        }
    } else {
        throw new Error('groupType parameter is missing in the route');
    }
};
